import { InfoOutlined } from "@mui/icons-material";
import { Card, CardContent, CardHeader, Divider, Grid, Stack, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { ViewToggleButtonGroup } from "../../../components";
import { useBreakpoints, useSettings } from "../../../hooks";
import { UserStrategicOwnershipContent } from "./UserStrategicOwnershipContent";
import { UserStrategyFilterButton } from "./UserStrategyFilterButton";

interface IParams {
  userId: string;
}

const UserStrategyPage = () => {
  const { userId: userGuid } = useParams<keyof IParams>() as IParams;
  const { isMdUp } = useBreakpoints();
  const { userStrategySettings, updateUserStrategySettings } = useSettings();
  const [isTableView, setIsTableView] = useState(userStrategySettings[userGuid]?.tableView ?? true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsTableView(userStrategySettings[userGuid]?.tableView ?? true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userStrategySettings, userGuid]);

  useEffect(() => {
    if (isMdUp) {
      setIsTableView(userStrategySettings[userGuid]?.tableView ?? true);
    } else {
      setIsTableView(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMdUp, userGuid]);

  function handleViewToggled(value: boolean) {
    updateUserStrategySettings(userGuid, {
      ...userStrategySettings[userGuid],
      tableView: value,
    });
  }

  return (
    <Grid container spacing={1} justifyContent="center">
      <Grid size={12}>
        <Card sx={{ p: 1 }}>
          <Stack direction="row" spacing={1} sx={{ justifyContent: "space-between", alignItems: "center" }}>
            <Stack>
              <Typography variant="h5">Strategy</Typography>
              <Typography>Personal ownership of strategic items</Typography>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              {isMdUp && <ViewToggleButtonGroup isTableView={isTableView} onViewToggled={handleViewToggled} />}
            </Stack>
          </Stack>
        </Card>
      </Grid>
      <Grid size={{ xs: 12, md: isTableView ? 12 : 8 }}>
        <Card>
          <CardHeader
            title={
              <Stack direction="row" spacing={0.25} flexGrow={1}>
                <Typography variant="h6">Strategic Ownership</Typography>
                <Tooltip title={"This view includes all owned strategic items."}>
                  <InfoOutlined sx={{ color: "grey.300", alignSelf: "center" }} />
                </Tooltip>
              </Stack>
            }
            action={<UserStrategyFilterButton userGuid={userGuid} disabled={isLoading} />}
          />
          <Divider />
          <CardContent>
            <UserStrategicOwnershipContent
              userGuid={userGuid}
              onLoaded={() => setIsLoading(false)}
              isTableView={isTableView}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export { UserStrategyPage };
